<template>
  <div class="d-flex align-items-center justify-content-center" style="min-height: 60vh">
    <b-card class="text-center" style="max-width: 520px">
      <feather-icon :icon="variant.icon" size="48" :class="`text-${variant.color} mb-1`" />
      <h3 class="mb-50">{{ variant.title }}</h3>
      <p class="text-muted">{{ variant.message }}</p>

      <div v-if="account" class="border rounded p-1 text-left my-1 small">
        <div><strong>Mailbox:</strong> {{ account.email }}</div>
        <div><strong>Provider:</strong> {{ account.provider }}</div>
        <div><strong>Status:</strong> {{ account.state }}</div>
      </div>

      <b-button variant="primary" :to="{ name: 'apps-mail-accounts-list' }">
        <feather-icon icon="ArrowLeftIcon" class="mr-50" />
        <span>Back to Mail Accounts</span>
      </b-button>
    </b-card>
  </div>
</template>

<script>
import { BCard, BButton } from 'bootstrap-vue';
import store from '@/store';
import mailAccountStoreModule from '../mailAccountStoreModule';

const STORE_MODULE_NAME = 'mailAccountStoreModule';

export default {
  components: { BCard, BButton },
  data: () => ({
    loading: true,
    account: null,
    error: null,
  }),
  computed: {
    status() {
      const s = this.$route.query.state || this.$route.query.status;
      if (this.error) return 'error';
      if (s === 'error' || this.$route.query.error) return 'error';
      return 'success';
    },
    variant() {
      if (this.status === 'error') {
        return {
          icon: 'AlertTriangleIcon',
          color: 'danger',
          title: 'Mailbox linking failed',
          message: this.error || this.$route.query.error_description || 'Authorization could not be completed.',
        };
      }
      return {
        icon: 'CheckCircleIcon',
        color: 'success',
        title: 'Mailbox linked',
        message: 'Your mailbox has been authorized. Sync may take a moment to complete.',
      };
    },
  },
  created() {
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, mailAccountStoreModule);
    this.loadStatus();
  },
  beforeDestroy() {
    if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME);
  },
  methods: {
    loadStatus() {
      const engineAccountId = this.$route.query.account;
      if (!engineAccountId) {
        this.loading = false;
        return;
      }
      // Find the local record (best-effort) and sync it
      this.$store
        .dispatch(`${STORE_MODULE_NAME}/fetchMailAccounts`, { limit: 1, search: engineAccountId })
        .then((response) => {
          const match = (response.data.results || []).find((a) => a.engineAccountId === engineAccountId);
          if (!match) return null;
          this.account = match;
          return this.$store.dispatch(`${STORE_MODULE_NAME}/syncMailAccount`, { id: match.id });
        })
        .then((response) => {
          if (response && response.data) this.account = response.data;
        })
        .catch((err) => {
          this.error = err?.response?.data?.message || err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
